import {UIEndGameShareImage} from './UIEndGameShareImage'
import {createDivIn, createExternalImgIn, createHeaderIn, createParagraphIn} from '../ui_utils/DomUtils'
import {UIGameManagerMethods} from '../ui_game/UIGameManager'
import {UIGamePlayerInformationView} from '../ui_game/ui_game_players/UIGamePlayerInformationView'
import {EnumUtils} from '@colonist/utils'
import {TranslationObject} from '@colonist/i18n'
import {EndGameState, PlayerColor, PlayerTitleEnum} from '@colonist/game-states'
import PlayerHighlight from '@static/images/player_highlight.png'
import {PlayerValidator} from '@colonist/game-mechanic-validators'

export class UIEndGameTitleImage extends UIEndGameShareImage {
    readonly title: PlayerTitleEnum

    constructor(uiGameManager: UIGameManagerMethods, title: PlayerTitleEnum, endGameState: EndGameState) {
        super(uiGameManager, endGameState)
        this.title = title
    }

    async generateImage() {
        this.createHeader()
        await super.generateImage()
        this.contentContainer.classList.add('with-header')
    }

    createHeader() {
        const header = createDivIn(this.container, 'share-image-header')
        const playerTitleTextDiv = createDivIn(header, 'share-image-header-text')

        const playerTitleKey = EnumUtils.getEnumKey(this.title, PlayerTitleEnum)
        const title: TranslationObject = {key: `strings:game.endGame.playerTitles.${playerTitleKey}.title`}
        const description: TranslationObject = {key: `strings:game.endGame.playerTitles.${playerTitleKey}.description`}

        createHeaderIn(playerTitleTextDiv, title, 'share-image-header-title')
        createParagraphIn(playerTitleTextDiv, description, 'share-image-header-description')
    }

    protected createPlayerAvatar(container: HTMLDivElement, player: PlayerValidator) {
        const isLocalPlayer = player.color == this.uiGameManager.gameController.myColor
        if(isLocalPlayer) {
            createExternalImgIn(container, PlayerHighlight, {key: 'strings:colonistCommon.utils.emptyString'}, 'share-image-player-highlight')
        }
        super.createPlayerAvatar(container, player)
    }

    // eslint-disable-next-line class-methods-use-this
    protected shouldCreatePlayerCrown(playerColor: PlayerColor, numPlayers: number): boolean {
        return false
    }

    protected sortPlayerViews(playerViews: UIGamePlayerInformationView[]) {
        const myPlayerIndex = playerViews.findIndex((playerView) => playerView.player.color == this.uiGameManager.gameController.myColor)

        if(myPlayerIndex == -1) return

        const lastPlayer = playerViews[playerViews.length - 1]
        playerViews[playerViews.length - 1] = playerViews[myPlayerIndex]
        playerViews[myPlayerIndex] = lastPlayer
    }
}
